<template>
	<div :id="blok.name" class="my-sm flex flex-row items-center">
		<v-icon :icon="blok.icon" class="mr-sm text-2xl" />

		<p>{{ blok.ingress }}</p>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

defineProps<{
	blok: Extract<BlokComponent, {component: "sb-languages"}>;
}>();
</script>
